import {
  formatTransferDate, formatTransferDateOnly, inventoryReplenishmentRequesterLabel,
  type InventoryRelocationRecord,
} from "./inventory-transfer-view";

const ROWS_PER_PAGE = 24;
function escapeHtml(value: string): string {
  return value.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;").replaceAll("'", "&#039;");
}

/** Separate sheets per PST, repeating the group and timestamp on continuation pages. */
export function inventoryRelocationListPrintPages(
  records: readonly InventoryRelocationRecord[], printedAt: Date = new Date(),
): string[] {
  const groups = new Map<string, InventoryRelocationRecord[]>();
  for (const record of records) {
    const group = groups.get(record.groupName) ?? [];
    group.push(record);
    groups.set(record.groupName, group);
  }
  const timestamp = formatTransferDate(printedAt.toISOString());
  const headings = ["依頼元", "依頼日", "依頼種別", "発送希望日", "在庫元", "➡", "依頼元", "商品名", "数量", "SKU"];
  return [...groups].flatMap(([name, items]) => {
    const pages: string[] = [];
    for (let offset = 0; offset < items.length; offset += ROWS_PER_PAGE) {
      const rows = items.slice(offset, offset + ROWS_PER_PAGE).map((record) => {
        const values = [
          inventoryReplenishmentRequesterLabel(record.requestedByEmail),
          formatTransferDateOnly(record.requestedAt), record.requestType,
          formatTransferDateOnly(record.desiredShippingDate), record.sourceLocationName ?? "", "➡",
          record.replenishmentLocationName ?? "",
          [record.productTitle.trim(), record.variantTitle.trim()].filter(Boolean).join(" ／ "),
          String(record.quantity), record.sku,
        ];
        return `<tr>${values.map((value) => `<td><span data-print-fit>${escapeHtml(value || "—")}</span></td>`).join("")}</tr>`;
      }).join("");
      pages.push(`<article class="inventory-relocation-list-print-page">
        <header><h2>在庫移管：${escapeHtml(name)} ／ 印刷日時：${escapeHtml(timestamp)}</h2>
          <span>${offset / ROWS_PER_PAGE + 1} / ${Math.ceil(items.length / ROWS_PER_PAGE)}</span></header>
        <table aria-label="${escapeHtml(name)}の在庫移管リスト">
          <colgroup>${[12, 8, 9, 8, 7, 2, 7, 25, 4, 18].map((width) => `<col style="width:${width}%">`).join("")}</colgroup>
          <thead><tr>${headings.map((heading) => `<th>${heading}</th>`).join("")}</tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </article>`);
    }
    return pages;
  });
}
